module.exports = __webpack_public_path__ + "static/media/loading.347f12fd.gif";